import { useState, useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';

// Peacock components
import { Button, DatePickerInput } from 'pepsico-ds';

// Custom Components
import { OnboardingStatusHeader } from '@/components/features/onboarding-status/OnboardingStatusHeader';
import OktaStatusTable from '@/containers/OnboardingStatus/OktaStatusTable';

// Constants
import { ROUTES } from '@/utils/constants/routesConstants';
import MissingProductListTable from '@/containers/OnboardingStatus/MissingProductListTable';
import VisitListRelatedDataTable from '@/containers/OnboardingStatus/VisitListRelatedDataTable';
import DateRangeSelector from '@/components/common/DateRangeSelector/DateRangeSelector';
const VisitListRelatedView = () => {
  const [dateRange, setDateRange] = useState({
    startDate: new Date(2023, 0, 1), // Jan 1, 2023
    endDate: (() => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow;
    })(),
    isValid: true
  });

  const location = useLocation();

  const shouldLoadData = useMemo(() => {
    return !!dateRange.startDate && !!dateRange.endDate && dateRange.isValid;
  }, [dateRange]);

  const config = useMemo(() => {
    const path = location.pathname;
    if (path.includes('missing-visit-list')) {
      return {
        title: 'Missing Visit List',
        filters: {
          filterMissingAnyEntry: true
        },
        downloadFileName: 'missing_visit_list.csv'
      };
    }
    if (path.includes('missing-moa')) {
      return {
        title: 'Missing MOA',
        filters: { filterMissingMoa: true },
        downloadFileName: 'missing_moa.csv'
      };
    }
    if (path.includes('missing-delivery-service')) {
      return {
        title: 'Missing Delivery Service',
        filters: { filterMissingDeliveryService: true },
        downloadFileName: 'missing_delivery_service.csv'
      };
    }
    if (path.includes('missing-delivery-days')) {
      return {
        title: 'Missing Delivery Days',
        filters: { filterMissingDeliveryDays: true },
        downloadFileName: 'missing_delivery_days.csv'
      };
    }
    if (path.includes('missing-cut-off-time')) {
      return {
        title: 'Missing Cutoff Time',
        filters: { filterMissingCutoffTime: true },
        downloadFileName: 'missing_cutoff_time.csv'
      };
    }
    return {
      title: 'Visit List',
      filters: {},
      downloadFileName: 'visit_list.csv'
    };
  }, [location.pathname]);

  return (
    <div>
      <DateRangeSelector
        onDatesChange={setDateRange}
        initialStartDate={dateRange.startDate}
        initialEndDate={dateRange.endDate}
      />

      {!shouldLoadData ? (
        <div className='text-center p-8'>
          <p>Please select both start and end dates to load the table data.</p>
        </div>
      ) : (
        <div className=''>
          <VisitListRelatedDataTable
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            config={config}
          />
        </div>
      )}
    </div>
  );
};

export default VisitListRelatedView;
